import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#08080A] grid lg:grid-cols-2" data-testid="admin-login-page">
      <div className="hidden lg:block relative grain">
        <img src="https://images.unsplash.com/photo-1660557989695-14fac79c086d?auto=format&fit=crop&w=1400&q=75" alt="" className="absolute inset-0 h-full w-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#08080A]" />
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <Link to="/" aria-label="Voltar ao site"><img src="/logo.png" alt="Gran Hotel Sé" className="h-12 w-auto" /></Link>
          <p className="label-caps mt-12">Área restrita</p>
          <h1 className="font-display text-4xl text-white mt-3">Painel administrativo</h1>
          <label className="block mt-10 text-xs uppercase tracking-[0.2em] text-[#A1A1AA]" htmlFor="email">E-mail</label>
          <input id="email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full h-12 bg-transparent border-b border-white/20 focus:border-[#C5A059] outline-none text-white transition-colors" data-testid="admin-login-email-input" />
          <label className="block mt-8 text-xs uppercase tracking-[0.2em] text-[#A1A1AA]" htmlFor="password">Senha</label>
          <input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full h-12 bg-transparent border-b border-white/20 focus:border-[#C5A059] outline-none text-white transition-colors" data-testid="admin-login-password-input" />
          {error && <p className="mt-6 text-sm text-red-400" role="alert" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} className="btn-lux btn-gold w-full mt-10 disabled:opacity-60" data-testid="admin-login-submit-button">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} Entrar
          </button>
        </form>
      </div>
    </div>
  );
}
